module.exports = __webpack_public_path__ + "static/media/call.b8224140.svg";